export default __webpack_public_path__ + "static/yardstats-44f745a0732b6f2d0d87516e82e10a8c.png";